var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148596",
    "data-name": "Rectangle 148596",
    width: 24,
    height: 24,
    fill: "#ff411a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "invite",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11727",
    "data-name": "Group 11727",
    transform: "translate(2.966 1.057)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "avatar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_208",
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_43",
    "data-name": "Union 43",
    d: "M-21610.959,15386.6h-.2a4.061,4.061,0,0,1-3.012-1.34c-1.687-1.9-1.371-5.17-1.35-5.35a4.4,4.4,0,0,1,2.143-3.949,4.839,4.839,0,0,1,2.338-.6h.07a4.847,4.847,0,0,1,2.338.612,4.417,4.417,0,0,1,2.121,3.938c.055.586.238,3.548-1.361,5.35a4.071,4.071,0,0,1-3.018,1.34Zm-.033-1.53h.006c.043,0,.086.006.125.006a2.539,2.539,0,0,0,1.865-.83c1.141-1.286,1.016-3.673.977-4.172a.25.25,0,0,1-.01-.076c-.115-2.512-1.682-3.076-2.969-3.108h-.043c-.852,0-2.836.3-2.967,3.108v.055l-.006.011c-.016.157-.232,2.81.982,4.183a2.508,2.508,0,0,0,1.984.824Z",
    transform: "translate(21619.566 -15375.556)",
    fill: "#ff411a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_44",
    "data-name": "Union 44",
    d: "M-21607.086,15385.036a20.64,20.64,0,0,1-7.947-1.99.723.723,0,0,1-.287-.364l-.006-.016a6.412,6.412,0,0,1-.223-1.942v-.13c.033-.863.1-2.875,2.029-3.543l.027-.011h.016a.048.048,0,0,1,.027,0,11.988,11.988,0,0,0,3.375-1.547.784.784,0,0,1,.434-.135.762.762,0,0,1,.623.325.761.761,0,0,1-.184,1.058,13.185,13.185,0,0,1-3.857,1.763c-.84.3-.937,1.221-.965,2.144,0,.026-.006.054-.006.075v.027a7.14,7.14,0,0,0,.07,1.15,18.342,18.342,0,0,0,6.934,1.633.755.755,0,0,1,.732.754.761.761,0,0,1-.754.76A.091.091,0,0,1-21607.086,15385.036Z",
    transform: "translate(21615.354 -15364.755)",
    fill: "#ff411a"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Union_45",
    "data-name": "Union 45",
    d: "M-21612.941,15377.953a12.741,12.741,0,0,1-2.283-1.21.747.747,0,0,1-.314-.494.735.735,0,0,1,.125-.569.752.752,0,0,1,.623-.325.793.793,0,0,1,.436.136,11.052,11.052,0,0,0,1.887,1.015l.012,0a.7.7,0,0,1,.357.716.8.8,0,0,1-.809.728Z",
    transform: "translate(21626.27 -15364.755)",
    fill: "#ff411a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11143",
    "data-name": "Group 11143",
    transform: "translate(11.108 14.924)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_47",
    "data-name": "Union 47",
    d: "M-21623.727,15367.044v-2.187h-2.187a.754.754,0,0,1-.75-.749.754.754,0,0,1,.75-.749h2.188v-2.183a.75.75,0,0,1,.748-.749.752.752,0,0,1,.75.749v2.183h2.182a.75.75,0,0,1,.748.749.751.751,0,0,1-.754.749h-2.176v2.187a.751.751,0,0,1-.75.749A.75.75,0,0,1-21623.727,15367.044Z",
    transform: "translate(21626.457 -15360.631)",
    fill: "#ff411a"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAdd);
export default __webpack_public_path__ + "static/media/user-add.a6bf55d6.svg";
export { ForwardRef as ReactComponent };